// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","donut-spin":"Spinner_donut-spin__YDPZN"};